module.exports = __webpack_public_path__ + "static/media/Nutrition.f8515b60.png";